import armCustomLevelIconMap from "./armCustomLevelIconMap";

export default function getARMToCustomLevel(level, partner) {
  const customLevelIcon = armCustomLevelIconMap[partner]?.[level];
  
  return customLevelIcon;
}